import {
  createDefaultGridV1DocumentValue,
  DEFAULT_GRID_V1_CELL_ID,
  type GridV1DocumentValue,
} from './grid-v1-types';

/** Single full-width cell containing the given markdown. */
export function createGridV1DocumentFromMarkdown(
  markdown: string,
): GridV1DocumentValue {
  const base = createDefaultGridV1DocumentValue();
  const template = base.widgets[0];
  if (!template) {
    return base;
  }

  return {
    ...base,
    widgets: [
      {
        ...template,
        id: DEFAULT_GRID_V1_CELL_ID,
        markdown,
      },
    ],
  };
}
